export interface MessageFeedback {
  type: 'positive' | 'negative';
  categories: string[];
  comment?: string;
}

export const POSITIVE_CATEGORIES = [
  'Accurate and helpful',
  'Well formatted',
  'Fast response',
  'Good use of data',
] as const;

export const NEGATIVE_CATEGORIES = [
  'Incorrect data',
  'Outdated information',
  'Poor formatting',
  'Not relevant to my question',
  'Too slow',
  'Missing context',
] as const;
